<template>
    <section style="top: 0px; right: 0px;">
        <div id="favorites">
            <div id="searchInputWrapper" class="flexContainer ai-c jc-sb" v-if="type === 'FAV'">
                <input id="searchInput" class="full" type="search" v-model="search" :placeholder="$t('common.search')" @keyup.enter="submit" />
                <div class="ai-c">
                    <img
                        id="cross"
                        src="../../../assets/cross.png"
                        alt=""
                        width="10"
                        height="10"
                        class="cross pointer"
                        @click="reset"
                        v-if="search !== ''"
                    />
                </div>
                <div class="ai-c"><img @click="submit" class="pointer" id="glass" src="../../../assets/loupe.png" /></div>
            </div>
            <div class="flexContainer" v-if="type === 'FAV'">
                <div class="center btnsFilter">
                    <button v-for="filter in filters" class="filterBtn" @click="filterAction(filter);">{{ getLabel(filter) }}</button>
                </div>
            </div>
            <div id="spinnerLoader" class="flexContainer abs" v-if="loading">
                <Spinner :animation-duration="5000" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
            </div>
            <div class="flexContainer abs full" id="noResults" v-if="getFavorites.length === 0 && loading === false">
                <h3 class="uppercase txtCenter" v-if="type === 'FAV'">{{ $t("favorite.noFavorite") }}</h3>
                <h3 class="uppercase txtCenter" v-else>{{ $t("scratchPad.noScratch") }}</h3>
            </div>
            <section id="favoritesContent" class="scrollY flexContainer fw-w">
                <div v-for="fav in getFavorites">
                    <div style="height: auto; width: 100px; position: relative; margin: 10px; overflow: hidden">
                        <img src="../../../assets/croix.png" @click="deleteFav(fav.id, fav.name);" style="position: absolute; right: 5px" />
                        <div><img :src="getUrlFav(fav)" @mousedown="copyFavory($event, fav);" width="100px" height="auto" /></div>
                        <div>{{ fav.name }}</div>
                    </div>
                </div>
            </section>
        </div>
    </section>
</template>

<script>
import { utilsMixin } from "../mixins/utils";

const d3 = require("d3"); // eslint-disable-line no-unused-vars

import Globals from "../../globals.js";
import { mapGetters, mapActions } from "vuex";
import { bus } from "../../../main";
import httpService from "../../service";
import Spinner from "vue-simple-spinner";
import { i18n } from "../../../main.js";
import { stateMixin } from "../mixins/state";
import cacheService from "@/services/cache";
// import ImageSvgCache from '../../../cache/ImageSvgCache'

export default {
    mixins: [stateMixin, utilsMixin],
    components: {
        Spinner
    },

    props: {
        typePlano: { type: String, default: "TILE" },
        type: { type: String, default: "FAV" },
        idPlano: { type: Number, default: 0 }
    },
    data: () => ({
        rollIndex: null,
        switchArrow: null,
        search: "",
        to: {},
        from: {},
        favorites: [],
        favoritesOrigin: [],
        loading: true,
        user: "",
        alpha: "",
        crois: "",
        fav: "",
        filters: []
    }),
    watch: {
        $route(to, from) {
            this.to = to;
            this.from = from;
            if (this._.size(to.query) === 0) {
                this.clearFilters();
            }
            if (this.$route.query.offset === undefined) {
                this.$route.query.offset = 1;
            }
            this.updateQuery(to);
        },
        loading() {}
    },
    methods: {
        ...mapActions("events/planomassmarket", {
            dispatchCopyFavorite: "dispatchCopyFavorite",
            dispatchCopyScratchpad: "dispatchCopyScratchpad"
        }),

        ...mapActions("plano/data", {
            listFavorites: "listFavorites",
            listFavoritesByUser: "listFavoritesByUser",
            listFavoritesSortName: "listFavoritesSortName",
            listFavoritesByName: "listFavoritesByName"
        }),

        filterFavs(favs) {
            return favs.filter(fav => {
                if (this.typePlano === "TILE") {
                    return !fav.favorite.type || fav.favorite.type === this.typePlano;
                } else {
                    return fav.favorite.type === this.typePlano;
                }
            });
        },

        getLabel(filter) {
            return filter.active ? filter.label2 : filter.label;
        },
        filterAction(filter) {
            filter.action(filter);
        },
        sortFav(filter) {
            let active = !filter.active;
            filter.active = active;
            let user = cacheService.getRem3rchUser().user;
            this.listFavoritesByUser(active ? user : null);
            // if (active) {
            //     this.favorites = this.favoritesOrigin.filter(fav => {
            //         return fav.createdUser.id === user.id
            //     })
            // } else {
            //     this.favorites = this.favoritesOrigin
            // }
        },
        sortName(filter) {
            let active = !filter.active;
            filter.active = active;
            this.listFavoritesSortName(!active);
            // if (active) {
            //     this.favorites = this.favoritesOrigin.sort((a, b) => {
            //         return a.name > b.name
            //     })
            // } else {
            //     this.favorites = this.favoritesOrigin.sort((a, b) => {
            //         return a.name < b.name
            //     })
            // }
        },
        sortDate(filter) {
            let active = !filter.active;
            filter.active = active;
            if (active) {
                this.favorites = this.favoritesOrigin.sort((a, b) => {
                    return a.id - b.id;
                });
            } else {
                this.favorites = this.favoritesOrigin.sort((a, b) => {
                    return b.id - a.id;
                });
            }
        },
        clearFilters() {
            bus.$emit("resetFilters", "");
        },
        reset() {
            this.search = "";
            this.favorites = this.favoritesOrigin;
        },
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        submit() {
            // this.favorites = this.favoritesOrigin.filter((fav) => {
            //     if (!fav.name) {
            //         return true
            //     }
            //     return fav.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            // })
            if (this.type === "FAV") {
                let name = !this.search ? null : this.search;
                this.listFavoritesByName(name);
            }
        },
        copyFavory(event, fav) {
            bus.$emit("fav_copyFav", { event: event, fav: fav.favorite, svg: event.target });
            // console.log(fav)
            if (this.type === "FAV") {
                this.dispatchCopyFavorite({
                    event: event,
                    data: fav.favorite,
                    elt: event.target,
                    id: fav.id
                });
            } else {
                this.dispatchCopyScratchpad({
                    event: event,
                    data: fav.favorite,
                    elt: event.target,
                    id: fav.id
                });
            }
        },
        getUrlFav(fav) {
            return Globals.getBaseUrl() + "/" + fav.favoritePath + fav.favoriteName;
        },

        deleteFav(favId, favName) {
            let realUrl = this.type === "FAV" ? "/favorites/" + favId : "/favorites/scratchPad/" + favId;
            this.favorites = [];
            let confirmTitle;
            let warningText;
            let confirmDelete;
            if (i18n.locale === "fr") {
                confirmTitle = "Supprimer le favoris " + favName + " ?";
                warningText = "Etes-vous de vouloir supprimer ? Vous ne pourrez plus revenir en arrière!";
                confirmDelete = "Supprimer!";
            } else if (i18n.locale === "en") {
                confirmTitle = "Delete " + favName + " favorite?";
                warningText = "Are you sure? You won't be able to revert this!";
                confirmDelete = "Yes, Delete it!";
            }
            this.$swal({
                title: confirmTitle,
                text: warningText,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#41b4e8",
                confirmButtonText: confirmDelete,
                closeOnConfirm: true
            }).then(result => {
                if (result === true) {
                    let idPlano = this.idPlano === 0 ? null : this.idPlano;
                    httpService.delete(realUrl).then(response => {
                        this.listFavorites(idPlano);
                        this.loading = false;
                    });
                } else {
                }
            });
        }
    },
    computed: {
        ...mapGetters({
            getFavorites: "plano/data/getFavorites"
        }),
        filteredFav() {
            return this.favorites.filter(fav => {
                if (!fav.name) {
                    return true;
                }
                return fav.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
            });
        }
    },
    created() {
        this.filters = [
            { id: "asc", label: "A..Z", label2: "Z..A", active: false, action: this.sortName },
            { id: "ascDate", label: "Croissant", label2: "Décroissant", active: false, action: this.sortDate },
            { id: "fav", label: "Tous les fav", label2: "Mes fav", active: false, action: this.sortFav }
        ];

        this.loading = true;
        let idPlano = this.idPlano === 0 ? null : this.idPlano;
        this.listFavorites(idPlano).then(favs => {
            favs = this.filterFavs(favs);
            this.favorites = favs;
            this.favoritesOrigin = favs;
            this.loading = false;
        });
        this.alpha = "A..Z";
        this.crois = "Moins récent au plus récent";
        this.fav = "Mes favoris";
    }
};
</script>

<style lang="scss" scoped>
.btnsFilter {
    margin-bottom: 20px;
}

.filterBtn {
    background: transparent;
    border-radius: 2rem;
    border: 1px solid #343434;
    font-size: 1.4rem;
    text-decoration: none;
    color: #343434;
}

#favorites {
    background: #fff;
    height: calc(100vh - 176px);
    #searchInputWrapper {
        padding: 15px;
        #searchInput {
            height: 30px;
            border-left: none;
            border-top: none;
            border-right: none;
            font-size: 14px;
        }
        #cross {
            position: relative;
            right: 15px;
        }
    }
    #noResults {
        height: 100%;
        h3 {
            margin: auto;
        }
    }
    #spinnerLoader {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        z-index: 10;
        .loader {
            margin: auto;
        }
    }
    #filtersPlano {
        padding: 15px;
        .sections {
            padding-left: 0;
            li {
                background-color: #eeeeee;
                padding: 10px 15px;
                font-size: 14px;
                &.active {
                    background-color: #41b4e8;
                    color: #fff;
                    &:after {
                        content: "";
                        position: absolute;
                        bottom: -6px;
                        width: 0px;
                        height: 0px;
                        border-left: 7px solid transparent;
                        border-right: 7px solid transparent;
                        border-top: 7px solid #41b4e8;
                    }
                }
            }
        }
    }
    #favoritesContent {
        height: 100%;
        padding: 0px 15px 0px 15px;
        max-height: calc(100vh - 250px);
        background-color: #ffffff;
    }
}
</style>



// WEBPACK FOOTER //
// Favorite.vue?2ab0ecdb